<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import ListItemElement from "../../components/pagesbuilder/elements/ListItemElement";
    

    export default {
        name: "PreviewListItemElement",
        mixins: [PreviewElement, ListItemElement]
    }
</script>
